import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {getItem} from "../../redux/cache/cacheService";
import {codes} from "../../redux/notificationCodes";
import React, {useEffect, useRef} from "react";
import {getNotificationMessage} from "../../redux/api/apiNotifications";
import {Toast} from "primereact/toast";
import {getNotification} from "../../redux/api/api";
import {hideError} from "../../redux/actions/actions";
import {SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../../redux/types/typesUsersList";
import {hostname} from "../../redux/config";

const GENERIC_ERROR = 'Щось пішло не так.';

function toUserFacingError(message?: unknown) {
    if (typeof message !== 'string') {
        return GENERIC_ERROR;
    }
    const text = message.trim();
    if (!text || /object reference not set|nullreferenceexception|exception of type/i.test(text)) {
        return GENERIC_ERROR;
    }
    return text;
}

const Notifications = () => {
    const dispatch = useAppDispatch();
    const toast = useRef<Toast>(null);
    const errorShownRef = useRef<boolean>(false);
    const isInitialLoadRef = useRef<boolean>(true);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const getNotificationError = useAppSelector(state => state.CompaniesListReducer.getNotificationError);
    const getCompaniesIntervalError = useAppSelector(state => state.CompaniesListReducer.getCompaniesIntervalError);
    const getArchivedCompaniesError = useAppSelector(state => state.CompaniesListReducer.getArchiveCompaniesError);
    const getCampaignDirectoriesPhoneTypeError = useAppSelector(state => state.CompaniesListReducer.getCampaignDirectoriesPhoneTypeError);
    const getCampaignDirectoriesCampaignTypeError = useAppSelector(state => state.CompaniesListReducer.getCampaignDirectoriesCampaignTypeError);
    const getCampaignDirectoriesGetTranksPhonesError = useAppSelector(state => state.CompaniesListReducer.getCampaignDirectoriesGetTranksPhonesError);
    const getCampaignDirectoriesStrategyError = useAppSelector(state => state.CompaniesListReducer.getCampaignDirectoriesStrategyError);
    const errorUpdate = useAppSelector(state => state.CompaniesListReducer.errorUpdate);
    const errorMessage = useAppSelector(state => state.CompaniesListReducer.errorMessage);
    const companyCreateMessage = useAppSelector(state => state.CompaniesListReducer.companyCreateMessage);
    const companyDeleteMessage = useAppSelector(state => state.CompaniesListReducer.companyDeleteMessage);
    const companySaveMessage = useAppSelector(state => state.CompaniesListReducer.companySaveMessage);
    const accessDeniedError = useAppSelector(state => state.NotificationsReducer.accessDeniedError);
    const notFoundError = useAppSelector(state => state.NotificationsReducer.notFoundError);
    const notifications = useAppSelector(state => state.NotificationsReducer);
    const notificationsError = useAppSelector(state => state.NotificationsReducer.error);
    const companies = useAppSelector(state => state.CompaniesListReducer);
    const error = useAppSelector(state => state.CompaniesListReducer.error);
    const branchDeleteResponseMessage = useAppSelector(state => state.BranchesListReducer.branchDeleteResponseMessage);
    const setUserStatus = useAppSelector(state => state.UsersListReducer.setUserStatus);
    const setFileUploadStatus = useAppSelector(state => state.UsersListReducer.setFileUploadStatus);
    const setUserStatusError = useAppSelector(state => state.UsersListReducer.setUserStatusError);
    const errorTokenNotification = useAppSelector(state => state.NotificationsReducer.errorTokenNotification);

    let accessDeniedNotification = getItem(codes.user_access_denied_messages);
    let notFoundNotification = getItem(codes.not_found_message);
    let successNotification = getItem(codes.success);
    let updateNotification = getItem(codes.update);
    let user_deleted_messages = getItem(codes.user_deleted_messages);
    let user_delete_questions = getItem(codes.user_delete_questions);
    let cancelNotification = getItem(codes.cancel);
    let copyNotification = getItem(codes.copy);
    let archive_branch_question = getItem(codes.archive_branch_question);
    let archive_role_question = getItem(codes.archive_role_question);
    let archive_status_question = getItem(codes.archive_status_question);
    let archive_queue_question = getItem(codes.archive_queue_question);
    let un_archive_queue_question = getItem(codes.un_archive_queue_question);
    let copy_queue_question = getItem(codes.copy_queue_question);
    let archive_qualification_group_question = getItem(codes.archive_qualification_group_question);
    let copy_qualification_group_question = getItem(codes.copy_qualification_group_question);
    let un_archive_qualification_group_question = getItem(codes.un_archive_qualification_group_question);
    let copy_status = getItem(codes.copy_status);
    let copy_role = getItem(codes.copy_role);
    let audioDeletedMessage = getItem(codes.audio_delete_questions);
    let unzipNotification = getItem(codes.un_archive_audio_question);


    useEffect(() => {
        if (user && user.userId) {
            if (!successNotification && !getNotificationError) {
                dispatch(getNotification(user.userId, 109, user));
            }
            if (!updateNotification && !getNotificationError) {
                dispatch(getNotification(user.userId, 110, user));
            }
            if (!user_delete_questions && !getNotificationError) {
                dispatch(getNotification(user.userId, 130, user));
            }
            if (!user_deleted_messages && !getNotificationError) {
                dispatch(getNotification(user.userId, 126, user));
            }
            if (!audioDeletedMessage && !getNotificationError) {
                dispatch(getNotification(user.userId, 219, user));
            }
            if (!unzipNotification && !getNotificationError) {
                dispatch(getNotification(user.userId, 220, user));
            }
            if (!cancelNotification && !getNotificationError) {
                dispatch(getNotification(user.userId, 107, user));
            }
            if (!copyNotification && !getNotificationError) {
                dispatch(getNotification(user.userId, 108, user));
            }
        }
    }, [getNotificationError]);

    useEffect(() => {
        if (user && user.userId) {
            if (!accessDeniedNotification && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 131, user));
            }
            if (!notFoundNotification && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 132, user));
            }
            if (!archive_branch_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 133, user));
            }
            if (!archive_status_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 153, user));
            }
            if (!archive_qualification_group_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 190, user));
            }
            if (!copy_status && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 199, user));
            }
            if (!copy_role && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 200, user));
            }
            if (!archive_role_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 144, user));
            }
            if (!archive_queue_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 171, user));
            }
            if (!un_archive_queue_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 173, user));
            }
            if (!copy_queue_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 164, user));
            }
            if (!copy_qualification_group_question && !notificationsError) {
                dispatch(getNotificationMessage(user.userId, 193, user));
            }
        }
    }, [notificationsError, user]);

    useEffect(() => {

        //исправить
        if (getNotificationError) {
            // toast?.current?.show({severity: 'error', summary: 'Помилка завантаження даних', detail: '', life: 3000});
        }

    }, [getNotificationError]);

    useEffect(() => {
        if (companyDeleteMessage) {
            toast?.current?.show({severity: 'success', summary: 'Компанія переміщена в архів.', detail: '', life: 3000});
        }

    }, [companyDeleteMessage]);

    const isValidPasswordShownRef = useRef<boolean>(false);

    useEffect(() => {
        if (user?.isValidPassword === false) {
            if (!isValidPasswordShownRef.current) {
                toast?.current?.show({severity: 'error', summary: 'Будь ласка змініть тимчасовий пароль :)', detail: '', life: 3000});
                isValidPasswordShownRef.current = true;
            }
        } else {
            isValidPasswordShownRef.current = false;
        }

    }, [user?.isValidPassword]);

    useEffect(() => {
        if (isInitialLoadRef.current && user?.userId && user?.jwtToken?.jwtToken) {
            isInitialLoadRef.current = false;
            if (error) {
                dispatch(hideError());
            }
            return;
        }

        if (error) {
            if (!errorShownRef.current) {
                toast?.current?.show({severity: 'error', summary: GENERIC_ERROR, detail: '', life: 3000});
                errorShownRef.current = true;
                dispatch(hideError());
            }
        } else {
            errorShownRef.current = false;
        }

    }, [error, user?.userId, user?.jwtToken?.jwtToken, dispatch]);

    useEffect(() => {
        if (errorUpdate) {
            toast?.current?.show({severity: 'error', summary: GENERIC_ERROR, detail: '', life: 3000});
            dispatch(hideError());
        }

    }, [errorUpdate, dispatch]);

    useEffect(() => {
        if (companyCreateMessage) {
            const notificationText = companies?.notificationSuccess?.text || successNotification;
            if (notificationText) {
                toast?.current?.show({severity: 'success', summary: notificationText, detail: '', life: 3000});
            } else {
                if (!getNotificationError && user?.userId && user?.jwtToken?.jwtToken) {
                    dispatch(getNotification(user.userId, 109, user.jwtToken.jwtToken, function (message: string) {
                        toast?.current?.show({severity: 'success', summary: message, detail: '', life: 3000});
                    }));
                }
            }
        }

    }, [companyCreateMessage, getNotificationError, successNotification, companies?.notificationSuccess, user?.userId, user?.jwtToken?.jwtToken]);

    useEffect(() => {
        if (companySaveMessage) {
            const notificationText = companies?.notificationUpdated?.text || updateNotification;
            if (notificationText) {
                toast?.current?.show({severity: 'success', summary: notificationText, detail: '', life: 3000});
            } else {
                if (!getNotificationError && user?.userId && user?.jwtToken?.jwtToken) {
                    dispatch(getNotification(user.userId, 110, user.jwtToken.jwtToken, function (message: string) {
                        toast?.current?.show({severity: 'success', summary: message, detail: '', life: 3000});
                    }));
                }
            }
        }

    }, [companySaveMessage, getNotificationError, updateNotification, companies?.notificationUpdated, user?.userId, user?.jwtToken?.jwtToken]);

    useEffect(() => {
        if (errorMessage) {
            toast?.current?.show({severity: 'error', summary: toUserFacingError(errorMessage), detail: '', life: 4000});
        }
    }, [errorMessage]);

    useEffect(() => {
        if (getCompaniesIntervalError) {
            toast?.current?.show({severity: 'error', summary: 'Помилка завантаження кампаній', detail: '', life: 4000});
        }
    }, [getCompaniesIntervalError]);

    useEffect(() => {
        if (getArchivedCompaniesError) {
            toast?.current?.show({severity: 'error', summary: 'Помилка завантаження архівних кампаній', detail: '', life: 4000});
        }
    }, [getArchivedCompaniesError]);

    useEffect(() => {
        if (getCampaignDirectoriesPhoneTypeError) {
            toast?.current?.show({severity: 'error', summary: 'Помилка завантаження типів телефонів', detail: '', life: 4000});
        }
    }, [getCampaignDirectoriesPhoneTypeError]);

    useEffect(() => {
        if (getCampaignDirectoriesCampaignTypeError) {
            toast?.current?.show({severity: 'error', summary: 'Помилка завантаження типів кампаній', detail: '', life: 4000});
        }
    }, [getCampaignDirectoriesCampaignTypeError]);

    useEffect(() => {
        if (getCampaignDirectoriesGetTranksPhonesError) {
            toast?.current?.show({severity: 'error', summary: 'Помилка завантаження транков кампаній', detail: '', life: 4000});
        }
    }, [getCampaignDirectoriesGetTranksPhonesError]);

    useEffect(() => {
        if (getCampaignDirectoriesStrategyError) {
            toast?.current?.show({severity: 'error', summary: 'Помилка завантаження стратегії операторів', detail: '', life: 4000});
        }
    }, [getCampaignDirectoriesStrategyError]);


    useEffect(() => {
        if (accessDeniedError) {
            const notificationText = notifications?.accessDeniedErrorMessage?.text || accessDeniedNotification;
            if (notificationText) {
                toast?.current?.show({severity: 'error', summary: notificationText, detail: '', life: 3000});
            } else {
                if (!notificationsError && user?.userId) {
                    dispatch(getNotificationMessage(user.userId, 131, user, function (message: string) {
                        toast?.current?.show({severity: 'error', summary: message, detail: '', life: 3000});
                    }));
                }
            }
        }

    }, [accessDeniedError, accessDeniedNotification, notifications?.accessDeniedErrorMessage, notificationsError, user?.userId]);

    useEffect(() => {
        if (notFoundError) {
            const notificationText = notifications?.notFoundErrorMessage?.text || notFoundNotification;
            if (notificationText) {
                toast?.current?.show({severity: 'error', summary: notificationText, detail: '', life: 3000});
            } else {
                if (!notificationsError && user?.userId) {
                    dispatch(getNotificationMessage(user.userId, 132, user, function (message: string) {
                        toast?.current?.show({severity: 'error', summary: message, detail: '', life: 3000});
                    }));
                }
            }
        }

    }, [notFoundError, notFoundNotification, notifications?.notFoundErrorMessage, notificationsError, user?.userId]);

    useEffect(() => {
        if (branchDeleteResponseMessage) {
            if (branchDeleteResponseMessage.statusCode === 200) {
                toast?.current?.show({severity: 'success', summary: branchDeleteResponseMessage?.message, detail: '', life: 3000});
            } else {
                toast?.current?.show({severity: 'error', summary: branchDeleteResponseMessage?.message, detail: '', life: 3000});
            }
        }

    }, [branchDeleteResponseMessage]);

    useEffect(() => {
        if (setUserStatus) {
            const message = typeof setUserStatus === 'string' ? setUserStatus : setUserStatus?.message;
            toast?.current?.show({severity: 'success', summary: message, detail: '', life: 3000});
            dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
        }
        if (setUserStatusError) {
            const errorMessage = typeof setUserStatusError === 'string' ? setUserStatusError : setUserStatusError?.message;
            toast?.current?.show({severity: 'error', summary: toUserFacingError(errorMessage), detail: '', life: 3000});
            dispatch({type: SET_USER_STATUS_ERROR, payload: null});
        }
    }, [setUserStatusError, setUserStatus, dispatch]);

    useEffect(() => {
        if (setFileUploadStatus) {
            toast?.current?.show({severity: 'success', summary: setFileUploadStatus?.message, detail: '', life: 86400000});
        } else {
            toast?.current?.clear();
        }
    }, [setFileUploadStatus]);

    useEffect(() => {
        if (errorTokenNotification) {
            toast?.current?.show({severity: 'error', summary: 'Втрачено зв\'язок з сервером! \n' +
                    `Оновіть вкладку: ${hostname}`, detail: '', life: 86400000});
        } else {
            toast?.current?.clear();
        }
    }, [errorTokenNotification]);

    return (
        <Toast style={{zIndex: 10000}} position="bottom-right" ref={toast}/>
    );
}

export default Notifications;
